<template>
  <button
    :class="[
      s.btn,
      isClicked ? s.isClicked : '',
      textNoWrap ? s.textNoWrap : '',
    ]"
    :style="`background-color: ${bgColor};`">
    <slot/>
  </button>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'large-btn',
  mixins: [cf],
  props: {
    color: {
      type: String,
      default: 'blue',
    },
    statusName: {
      type: String,
      default: null,
    },
    statusFlag: {
      type: Number,
      default: null,
    },
    officeId: {
      type: Number,
      default: null,
    },
    isClicked: {
      type: Boolean,
      default: false,
    },
    textNoWrap: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['helper']),
    bgColor() {
      if (this.statusFlag != null) {
        return this.getStatusHexByFlag(this.officeId, this.statusFlag);
      }
      if (this.statusName) {
        return this.getStatusHex(this.officeId, this.statusName);
      }
      return this.helper.master.colors?.[this.color] || '#ADB5BD';
    },
  },
};
</script>

<style lang="scss" module="s">
.btn {
  font-size: 32px;
  font-weight: bold;
  height: var(--large-btn-h);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: var(--primary-blue);
  opacity: 1;
  border: none;
  border-radius: 4px;
  text-align: center;
  line-height: 1.2;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    // border: 4px solid;
    // border-color: rgba(#ffffff, .2) rgba(#000000, .2) rgba(#000000, .2) rgba(#ffffff, .2);
  }

  &.isClicked {
    color: #ffffff;
    border: none;
  }

  &.textNoWrap {
    white-space: nowrap;
  }

  &:disabled {
    border: none;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 0; left: 0;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      background-color: rgba(#000000, .5);
      mix-blend-mode: multiply;
    }
  }
}
</style>
